(function () {
  function refetch(root) {
    if (root.dataset.ccVariantRefetch === 'done') return;
    root.dataset.ccVariantRefetch = 'done';

    var sectionId = root.getAttribute('data-cc-section-id');
    if (!sectionId) return;

    var params = new URLSearchParams(window.location.search);
    params.set('section_id', sectionId);

    fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var freshGrid = temp.querySelector('.product-grid');
        var currentGrid = root.querySelector('.product-grid');
        if (!freshGrid || !currentGrid) return;
        if (freshGrid.children.length <= currentGrid.children.length) return;

        var currentSlider = root.querySelector('carousel-slider');
        var freshSlider = temp.querySelector('carousel-slider');

        if (currentSlider && freshSlider) {
          currentSlider.parentNode.replaceChild(freshSlider, currentSlider);
        } else {
          currentGrid.parentNode.replaceChild(freshGrid, currentGrid);
        }

        window.dispatchEvent(new Event('resize'));
      })
      .catch(function () { /* Fallback: serverseitig gerendertes Grid bleibt stehen */ });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cc-section-id]');
    for (var i = 0; i < roots.length; i++) refetch(roots[i]);
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('carousel-slider').then(boot, boot);
      setTimeout(boot, 3000);
    } else {
      boot();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
